interface Config {
  ENV: string;
  API_URL: string;
  API_URL_NOVA: string;
  BASKET_API_URL: string;
  METRICS_API_URL: string;
  INVOICE_VIEWER_API_URL: string;
  SITE_URL: string;
  COOKIE_DOMAIN: string;
  LENS_URL: string;
  CMS_API_URL: string;
  TUTORIAL_VIDEO_ID: string;
  GRAPHQL_API: string;
  GRAPHQL_API_CODEGEN: string;
  METRIC_API: string;
  API_URL_V2: string;
  REPOSITORIO_URL: string;
  PANEL_URL: string;
  ZOOP_API_URL: string;
  ZOOP_MARKETPLACE_ID: string;
  ZOOP_API_KEY: string;
  CHECKOUT_API_URL: string;
}

const configStg: Config = {
  ENV: 'stg',
  API_URL: 'https://stg-api.haytek.com.br/v1.1',
  METRICS_API_URL: 'https://api.haytek.com.br/api/v1/metrics',
  BASKET_API_URL: 'https://stg-api.haytek.com.br/api/v1/basket/v1.0',
  API_URL_NOVA: 'https://stg-api.haytek.com.br/api/v1',
  INVOICE_VIEWER_API_URL: 'https://stg-api.haytek.com.br/api/v1/invoice-viewer',
  SITE_URL: 'https://stg.haytek.com.br',
  COOKIE_DOMAIN: '.haytek.com.br',
  LENS_URL: 'https://repositorio.lenteshaytek.com.br/',
  CMS_API_URL: 'https://stg-api.haytek.com.br/api/v1/cms',
  TUTORIAL_VIDEO_ID: '4JD9OEao0YM',
  GRAPHQL_API: 'https://stg-api.haytek.com.br/api/v1/graphql/graphql',
  GRAPHQL_API_CODEGEN: 'https://stg-api.haytek.com.br/api/v1/graphql/graphql',
  METRIC_API: 'https://stg-api.haytek.com.br/api/v1/metrics/collect/',
  API_URL_V2: 'https://stg-api.haytek.com.br/v2',
  REPOSITORIO_URL: 'https://repositorio.lenteshaytek.com.br/',
  PANEL_URL: 'https://stg-vendas.haytek.com.br',
  ZOOP_API_URL: 'https://api.zoop.ws/v1/marketplaces',
  ZOOP_MARKETPLACE_ID: 'e5207df84767456b94c41371e1fe377d',
  ZOOP_API_KEY: 'enBrX3Rlc3RfSzJBbzFPeXBpRnlGVTlreFR3Y21iWDhROjE4ZjY0NTBhNmEyZTRkNDY4YjQ5NThjZGM4ZjQ4Mzk0',
  CHECKOUT_API_URL: 'https://stg-api.haytek.com.br/api/v1/checkout',
};

const configProd: Config = {
  ENV: 'prd',
  API_URL: 'https://api.haytek.com.br/v1.1',
  METRICS_API_URL: 'https://api.haytek.com.br/api/v1/metrics',
  API_URL_NOVA: 'https://api.haytek.com.br/api/v1',
  INVOICE_VIEWER_API_URL: 'https://api.haytek.com.br/api/v1/invoice-viewer',
  BASKET_API_URL: 'https://api.haytek.com.br/api/v1/basket/v1.0',
  SITE_URL: 'https://haytek.com.br',
  COOKIE_DOMAIN: 'haytek.com.br',
  LENS_URL: 'https://repositorio.lenteshaytek.com.br/',
  CMS_API_URL: 'https://api.haytek.com.br/api/v1/cms',
  TUTORIAL_VIDEO_ID: '4JD9OEao0YM',
  GRAPHQL_API: 'https://api.haytek.com.br/api/v1/graphql/graphql',
  GRAPHQL_API_CODEGEN: 'https://api.haytek.com.br/api/v1/graphql/graphql',
  METRIC_API: 'https://api.haytek.com.br/api/v1/metrics/collect/',
  API_URL_V2: 'https://api.haytek.com.br/v2',
  REPOSITORIO_URL: 'https://repositorio.lenteshaytek.com.br/',
  PANEL_URL: 'https://vendas.haytek.com.br',
  ZOOP_API_URL: 'https://api.zoop.ws/v1/marketplaces',
  ZOOP_MARKETPLACE_ID: 'af6f2306c8944c9a8d14538486e2a0b1',
  ZOOP_API_KEY: 'enNrX3Byb2RfTm5NV0Qyb3F4RWJaSWd2NWtQU0FoVTl4OjU4NjJiN2QxZGE0YjRjZjA4ZmY5MmM3NzRlMjJhZTJk',
  CHECKOUT_API_URL: 'https://api.haytek.com.br/api/v1/checkout',
};

const configDev: Config = {
  ...configProd,
  // ...configStg,
  GRAPHQL_API: 'http://localhost:8080/graphql',
  GRAPHQL_API_CODEGEN: 'http://localhost:8080/graphql',
  SITE_URL: 'http://localhost:5173',
  COOKIE_DOMAIN: 'localhost',
  // CHECKOUT_API_URL: 'http://localhost:3007',
};

const getEnv = () => {
  if (process.env.NODE_ENV == 'staging') {
    return configStg;
  }
  if (process.env.NODE_ENV == 'development') {
    return configDev;
  }

  return configProd;
};

export default getEnv();
